// extracted by mini-css-extract-plugin
module.exports = {"button":"ContentTab_button__Bxjbj","content":"ContentTab_content__4OzGH"};